<script setup lang="ts">
defineProps<{
	current: number;
	total: number;
	isContactForm?: boolean;
}>();
</script>

<template>
  <div class="progress-container" :class="{ 'contact-form': isContactForm }">
    <div class="progress-bar">
      <div class="progress-fill" :style="{ width: `${(current / total) * 100}%` }"></div>
    </div>
  </div>
</template>

<style scoped>
.progress-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.progress-container.contact-form {
  margin-bottom: 8px;
}

.progress-bar {
  height: 16px;
  background-color: #fff;
  border-radius: 8px;
  width: 80%;
  margin: 8px;
  overflow: hidden;
  border: 1px solid #a5dbdf;
}

.progress-fill {
  height: 100%;
  background-color: #36b4a8;
  transition: width 0.3s ease;
}

.progress-text {
  text-align: right;
  font-size: 14px;
}

@media screen and (max-width: 767px) {
  .progress-container {
    margin-bottom: 10px;
  }
  
  .progress-container.contact-form {
    margin-bottom: 4px;
  }
}
</style>